import { gql } from "@apollo/client";

export const GET_STREAMS_BY_EVENT_ID = gql`
    query getStreamsByEventId($id: ID!) {
        event(id: $id) {
            streams {
                id
                url
                name
                protocol
                service
                metadata {
                    aspectRatio
                    serviceText
                    serviceImageUrl
                    thumbnailUrl
                }
            }
        }
    }
`;
